import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import IconPillButton from './IconPillButton';

interface SortIconButtonProps {
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  size?: 'sm' | 'md';
}

export default function SortIconButton({
  active = false,
  disabled = false,
  onClick,
  className = '',
  size = 'md'
}: SortIconButtonProps) {
  return (
    <IconPillButton
      icon={<ArrowUpDown size={size === 'sm' ? 18 : 20} />}
      ariaLabel="Sort"
      active={active}
      disabled={disabled}
      onClick={onClick}
      className={className}
      size={size}
    />
  );
}
